import type { FC } from "react";

import ImageLoader, { type IImageLoader } from "@Components/ImageLoader";
import { Link } from "@Components/Link";

import * as css from "./BenefitItem.module.css";

export interface IBenefitItem {
    image: IImageLoader;
    title: string;
    description: string;
    onClick: () => void;
    benefitType: BenefitType;
    tracker: string;
}

export enum BenefitType {
    Undefined,
    Tooltip,
    ScrollToDiscounts,
}

const BenefitItem: FC<IBenefitItem> = (props) => {
    const handlerClick = () => {
        if (props.benefitType === BenefitType.ScrollToDiscounts) {
            props.onClick();
        }

        return true;
    };

    return (
        <div className={css.benefitItemComponent}>
            <Link trackingUrl={props.tracker} onClick={() => handlerClick()} hideLoading={true}>
                <div className={css.image}>
                    <ImageLoader {...props.image} />
                </div>
                <div className={css.description}>
                    <h3 className={css.benefitTitle}>{props.title}</h3>
                    <h5 className={css.benefitDescription}>{props.description}</h5>
                </div>
            </Link>
        </div>
    );
};

export default BenefitItem;
